import { AnalyticsService } from '@dtx-company/connect-codegen/src/gen/analytics/v2/service_pb'
import { AssetSchema } from '@dtx-company/connect-codegen/src/gen/asset/v1/asset_pb'
import { Client, createClient } from '@connectrpc/connect'
import { CodeSchema } from '@dtx-company/connect-codegen/src/gen/codes/v2/code_pb'
import { PageSchema as V1Page } from '@dtx-company/connect-codegen/src/gen/pages/v1/page_pb'
import { PageSchema as V2Page } from '@dtx-company/connect-codegen/src/gen/pages/v2/page_pb'
import { createConnectTransport } from '@connectrpc/connect-web'
import { createRegistry } from '@bufbuild/protobuf'
import { getBaseUrl } from '../utils/url'

export const assetTypeRegistry = createRegistry(CodeSchema, V1Page, V2Page, AssetSchema)

export const getAnalyticsServiceBaseUrl = (): string =>
  getBaseUrl('analytics/internal/', process.env.APP_ENV)

const analyticsClient: Client<typeof AnalyticsService> = createClient(
  AnalyticsService,
  createConnectTransport({
    baseUrl: getAnalyticsServiceBaseUrl(),
    jsonOptions: {
      ignoreUnknownFields: true,
      registry: assetTypeRegistry
    }
  })
)

export default analyticsClient
